<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->

<button mat-raised-button color="primary" automationId="planPromiseNow" (click)="lockCurrentPeriod()">
	<mat-icon>push_pin</mat-icon>
	{{ promiseNowButtonText }}
</button>
